<!-- frontend/src/components/LanguageSwitcher.vue -->
<template>
    <div class="language-switcher">
      <div class="documentation-label">
        <i class="bi bi-book me-1"></i>
        {{ $t('languageSwitcher.documentation') }}
      </div>
      <div class="dropdown">
        <button 
          class="btn btn-language dropdown-toggle" 
          type="button" 
          id="languageDropdown" 
          data-bs-toggle="dropdown" 
          aria-expanded="false"
        >
          <i class="bi bi-globe me-2"></i>
          {{ $t('languageSwitcher.languages.' + currentLanguage) }}
        </button>
        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="languageDropdown">
          <li v-for="lang in languages" :key="lang">
            <a 
              class="dropdown-item" 
              :class="{ active: currentLanguage === lang }"
              href="#" 
              @click.prevent="changeLanguage(lang)"
            >
              {{ $t('languageSwitcher.languages.' + lang) }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </template>
  
  <script>
  import { useI18n } from 'vue-i18n';
  
  export default {
    name: 'LanguageSwitcher',
    setup() {
      const { locale } = useI18n();
      
      // Available languages
      const languages = ['en', 'de', 'sl', 'it', 'fr'];
      
      const changeLanguage = (lang) => {
        locale.value = lang;
        localStorage.setItem('language', lang);
        document.documentElement.lang = lang;
      };
      
      return {
        currentLanguage: locale,
        languages,
        changeLanguage
      };
    }
  };
  </script>
  
  <style scoped>
  .language-switcher {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .documentation-label {
    font-size: 0.85rem;
    color: #666;
    font-weight: 500;
    white-space: nowrap;
  }
  
  .btn-language {
    background-color: #f2f5e7;
    color: #333;
    border: 1px solid #87B140;
    border-radius: 20px;
    padding: 0.375rem 1rem;
    font-size: 0.9rem;
    transition: all 0.2s ease;
  }
  
  .btn-language:hover,
  .btn-language:focus {
    background-color: #87B140;
    color: white;
    border-color: #75a236;
  }
  
  .dropdown-menu {
    border-radius: 8px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
    padding: 0.5rem 0;
    min-width: 150px;
  }
  
  .dropdown-item {
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
    transition: all 0.2s ease;
  }
  
  .dropdown-item:hover {
    background-color: #f2f5e7;
    color: #87B140;
  }
  
  .dropdown-item.active {
    background-color: #87B140;
    color: white;
  }
  
  .dropdown-item.active:hover {
    background-color: #75a236;
    color: white;
  }
  
  @media (max-width: 576px) {
    .language-switcher {
      flex-direction: column;
      gap: 5px;
    }
    
    .documentation-label {
      font-size: 0.8rem;
    }
    
    .btn-language {
      padding: 0.25rem 0.75rem;
      font-size: 0.85rem;
    }
  }
  </style>